import styled from "styled-components";
import { Annotation, deleteAnnotation  } from "../../api/slideAPI";
import { DeleteOutlined } from "@ant-design/icons";
import { Popconfirm } from "antd";

interface Props {
    postId: number;
    annoList: Array<Annotation>;
    reloadAnnoList: () => void;
}

  
const AnnoListArea = ({ postId, annoList, reloadAnnoList }: Props) => {
  const handleDeleteAnno = async (annoId: number) => {
    await deleteAnnotation(annoId);
    reloadAnnoList();
  };

  return (
      <StAnnoListAreaContainer>
        <div style={{  display: "flex", flexDirection: "column", gap: "12px", height: "100%", overflowY: "auto" }}>
          <h3 style={{ margin: 0 }}>Annotations</h3>
          {annoList?.map((anno) => (
            <StAnnoItem key={anno?.annoId}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontSize: "16px" }}>{anno?.content}</div>
              <Popconfirm
                title="삭제하시겠습니까?"
                onConfirm={() => handleDeleteAnno(anno?.annoId)}
                okText="삭제"
                cancelText="취소"
              >
                <DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "16px" }} />
              </Popconfirm>
            </div>
          </StAnnoItem>
          ))}
        </div>
      </StAnnoListAreaContainer>
  );

}

export default AnnoListArea;

const StAnnoListAreaContainer = styled.div`
  padding: 16px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
`;

const StAnnoItem = styled.div`
  padding: 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background-color: #fafafa;
`;